import {useRef,useEffect, useState} from 'react';
import { useSelector,useDispatch } from 'react-redux';
import { modalModifShow,modif,updateFournisseur,currentfournisseur } from "./FournisseursSlice";
import axios from 'axios';

export default function ModalModifer() {

    const fournisseursData = useSelector(state => state.fournisseursData);
    const current = fournisseursData.currentFournisseur;
    const modalShow = fournisseursData.modalModifShow;
    const id = useSelector(state => state.userData.id);

    const [loading,setLoading] =useState(false)
    const [etat,setEtat] =useState('')


    const designationField=useRef()
    const cinField=useRef('')
    const compteField=useRef()
    const telField=useRef()
    const adresseField=useRef()
    const emailField=useRef()

    const ChampUpdate = () =>{
        const designation=designationField.current.value;
        const cin=cinField.current.value;
        const compte=compteField.current.value;
        const tel=telField.current.value;
        const adresse=adresseField.current.value;
        const email=emailField.current.value;
        const _id=current._id;
        const data={_id,designation,compte,tel,adresse,email,cin};
        dispatch(currentfournisseur(data));
    }

    const Ajouter = async ()=> {
        const designation=designationField.current.value.trim()
        const cin=cinField.current.value.trim()
        const compte=compteField.current.value.trim()
        const tel = telField.current.value.trim()
        const adresse = adresseField.current.value.trim()
        const email = emailField.current.value.trim()
        if(designation==="")
            {
                alert("Désignation vide");
                return;
            }
            setEtat('')
            setLoading(true)
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const idfournisseur = current._id;
            const response = await axios.post(`${apiUrl}edit/fournisseur/${id}/${idfournisseur}`, {
                designation,
                cin,
                compte,
                tel,
                adresse,
                email,
            });
            if(response.data.status==="ok")
                {
                    const data={idfournisseur,designation,cin,compte,tel,adresse,email};
                    dispatch(modalModifShow(false));
                    dispatch(modif(true));
                    dispatch(updateFournisseur(data));
                }
            else{
                setEtat('erreur');
            }
        } catch (error) {
            setEtat('erreur');
        }
        setLoading(false)
    }

    const dispatch= useDispatch();
    const Close = () => {
        dispatch(modalModifShow(false));
        setEtat('');
        
    };

    useEffect(() =>{
        setEtat('');
      },[]);

    return (
        <div className={`modal fade ${modalShow ? 'show' : ''}`} style={{ display: modalShow ? 'block' : 'none' }} role="dialog" aria-hidden="true">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Modifier fournisseur</h5>
                    </div>
                    <div className="modal-body">
                    {etat==='erreur' ?
                                <div class="alert alert-danger  mb-4 text-center" role="alert">
                                <strong>Erreur de connexion</strong>
                            </div>                 
                        :
                        ''                    
                    }
                    <label className="form-label" for="designation">Nom fournisseur</label>
                    <input type="text" className="form-control" id="designation" onChange={ChampUpdate} value={current.designation} placeholder="Nom du fournisseur" ref={designationField}></input>

                    <label className="form-label" for="cin">CIN</label>
                    <input type="text" className="form-control" id="designation" onChange={ChampUpdate} value={current.cin} placeholder="CIN" ref={cinField}></input>

                    <label className="form-label mt-4" for="tel">Tel.</label>
                    <input type="text" className="form-control" id="tel" onChange={ChampUpdate} value={current.tel} placeholder="Tel du fournisseur" ref={telField}></input>

                    <label className="form-label mt-4" for="tel">Adresse</label>
                    <input type="text" className="form-control" id="adresse" onChange={ChampUpdate} value={current.adresse} placeholder="Adresse du fournisseur" ref={adresseField}></input>

                    <label className="form-label mt-4" for="email">E-Mail</label>
                    <input type="text" className="form-control" id="email" onChange={ChampUpdate} value={current.email} placeholder="E-mail du fournisseur" ref={emailField}></input>

                    <label className="form-label mt-4" for="compte">N° Compte</label>
                    <input type="text" className="form-control" id="compte" onChange={ChampUpdate} value={current.compte} placeholder="N° de Compte du fournisseur" ref={compteField}></input>

                    </div>
                    <div className="modal-footer">
                        {loading ?
                        <>
                <div className="mt-4 d-flex justify-content-center">
                <button class="btn btn-success" type="button" disabled>
                <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                <span class="sr-only">Enregistrement...</span>
                </button>
                </div> 
                        </>
                        :
                        <>
                        <button type="button" className="btn btn-success" onClick={Ajouter}>Enregistrer</button>
                        <button type="button" className="btn btn-secondary" onClick={Close}>Annuler</button>
                        </>
                        }
                    </div>
                </div>
            </div>
        </div>
    );

    }


